import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-br-report-card',
  templateUrl: './report-card.component.html'
})
export class BrReportCardComponent {
  @Input() title: string;
}
